import { DraftAddEntityButton } from '../../Draft'
import { useEmailDraft } from '../Email.hooks'
import { EmailCreateActionButton } from '../EmailCreateActionButton'
import { EmailDraftCreateActionSelect } from '../EmailDraftCreateActionSelect'

function EmailAddButton({
  Button = EmailCreateActionButton,
  Select = EmailDraftCreateActionSelect,
  ...props
}) {
  const { draft, draftId } = useEmailDraft()

  return (
    <DraftAddEntityButton
      {...props}
      Button={Button}
      Select={Select}
      draft={draft}
      draftId={draftId}
    />
  )
}

export default EmailAddButton
